// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function CaretsInVerticalWithLine(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "CaretsInVerticalWithLine" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.5 21L4.5 21L12 15L19.5 21Z", fill: "currentColor" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 3L19.5 3L12 9L4.5 3Z", fill: "currentColor" }),
            React.createElement("path", { d: "M4 13.5L4 10.5L20 10.5L20 13.5L4 13.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=CaretsInVerticalWithLine.js.map